import { Tag, Text, theme } from '@/components';
import { ExclamationCircleFilled } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const WorkflowActionRequiredBadge: FC = () => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  const style = {
    width: 80,
    height: 26,
    borderColor: token.colorError,
    borderRadius: 13,
    color: token.colorPrimaryText,
    backgroundColor: token.colorErrorBg,
    marginInlineEnd: 0,
  };

  return (
    <Tag
      style={style}
      icon={<ExclamationCircleFilled style={{ color: token.colorError }} />}
    >
      <Text text={t('action-required')} />
    </Tag>
  );
};
